import React from 'react';
import PropTypes from 'prop-types';
import s from './PopoverSelect.styles';

const PopoverSelect = ({ options, onChange }) => (
  <s.Wrapper>
    <s.Scrollable>
      {options.map(option => (
        <s.Item key={option.value} onClick={() => onChange(option)}>
          {option.label}
        </s.Item>
      ))}
    </s.Scrollable>
  </s.Wrapper>
);

PopoverSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  onChange: PropTypes.func,
};

PopoverSelect.defaultProps = {};

export default React.memo(PopoverSelect);
